<template>
    <div>
      <top-nav></top-nav>
      <div class="label">{{label}}</div>
      <div class="mineMain">
        <div class="leftMenu">
            <div class="menuList">
                <div @click="changeNode(0,'个人资料')" :class="['node-one',{'node-oneChecked':checkedIndex===0}]">个人资料</div>
              <div class="node-one-Htitle">
                <div @click="changeNode(1,'场馆订单')" :class="['title',{'title-oneChecked':checkedIndex===1 || checkedIndex===2 || checkedIndex===3}]">我的订单</div>
                <div @click="changeNode(2,'场馆订单')" :class="['node-two',{'node-twoChecked':checkedIndex===2}]">场馆订单</div>
                <div @click="changeNode(3,'赛事订单')" :class="['node-two',{'node-twoChecked':checkedIndex===3}]">赛事订单</div>
              </div>
              <div @click="changeNode(4,'账号安全')" :class="['node-one',{'node-oneChecked':checkedIndex===4}]">账号安全</div>
            </div>
        </div>
        <div class="rightContent">
          <router-view></router-view>
        </div>
      </div>
      <bot-nav></bot-nav>
    </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      checkedIndex: 0,
      label:'个人中心',
    }
  },
  created() {
      this.initNodeIndex()
    },
  mounted() {

    },
  methods:{
    initNodeIndex(){
      let nodeIndex =JSON.parse(sessionStorage.getItem('nodeIndex'))
      if (nodeIndex){
        this.checkedIndex =parseInt(nodeIndex.index)
        this.label = nodeIndex.label
      }
    },
    changeNode(index,label){
      let nodeIndex = {
        index:index,
        label:label
      }
      sessionStorage.setItem('nodeIndex',JSON.stringify(nodeIndex))
      this.checkedIndex = index
      this.label = label
      switch (index) {
        case 0:
          this.$router.push('/mineCenter/mineData')
        break;
        case 1:
          this.$router.push('/mineCenter/MineOrderForGoods')
          break;
        case 2:
          this.$router.push('/mineCenter/MineOrderForGoods/VenueOrders')
          break;
        case 3:
          this.$router.push('/mineCenter/MineOrderForGoods/eventOrders')
          break;
        case 4:
          this.$router.push({path:'/mineCenter/accountSecurity',query:{showIndex:true}})
          break;
        default:
          break;
      }

    }
  }
}
</script>

<style lang="less" scoped>
.label{
  margin-left: 100px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
}
.mineMain{
  display: flex;
  //align-items: center;
  padding-top: 20px;
  margin-bottom: 30px;
  .leftMenu{
    width: 240px;
    height: calc(100vh - 514px);
    margin-left: 100px;
    .menuList{
      cursor: pointer;
      user-select: none;
      height: 100%;
      width: 100%;
      //border: 1px solid red;
      .node-one{
        height: 60px;
        background: #E0E0E0;
        //border: 1px solid yellow;
        line-height: 60px;
        padding-left: 70px;
        font-family: SourceHanSansCN-Bold;
        font-weight: 700;
        font-size: 17px;
        color: #333333;
      }
      .node-oneChecked{
        height: 60px;
        background: #0058A6;
        //border: 1px solid yellow;
        line-height: 60px;
        padding-left: 70px;
        font-family: SourceHanSansCN-Bold;
        font-weight: 700;
        font-size: 17px;
        color: #FFFFFF;
      }
      .node-one-Htitle{
        width: 100%;
        .title{
          height: 60px;
          width: 100%;
          background: #E0E0E0;
          //border: 1px solid yellow;
          line-height: 60px;
          padding-left: 70px;
          font-family: SourceHanSansCN-Bold;
          font-weight: 700;
          font-size: 17px;
          color: #333333;
        }
        .title-oneChecked{
          height: 60px;
          background: #0058A6;
          //border: 1px solid yellow;
          line-height: 60px;
          padding-left: 70px;
          font-family: SourceHanSansCN-Bold;
          font-weight: 700;
          font-size: 17px;
          color: #FFFFFF;
        }
        .node-two{
          width: 100%;
          height: 60px;
          background: #F2F2F2;
          line-height: 60px;
          padding-left: 90px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
        }
        .node-twoChecked{
          width: 100%;
          height: 60px;
          background: #F2F2F2;
          line-height: 60px;
          padding-left: 90px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 16px;
          color: #0058A6;
        }
      }
    }
  }
  .rightContent{
    flex: 1;
    margin-left: 24px;
    margin-right: 100px;
    //border: 1px solid red;
  }
}
</style>
